import { render, staticRenderFns } from "./OperaDeclareWindow.vue?vue&type=template&id=316b55bd&"
import script from "./OperaDeclareWindow.vue?vue&type=script&lang=js&"
export * from "./OperaDeclareWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports